import { makeStyles } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";


export default makeStyles(theme => ({
  root: {},
  brandLogoTitle: {
    fontWeight: 'normal',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '1.5rem'
  },
}))

export const getMuiTheme = (selectedTheme) => {
    return createMuiTheme({
      ...selectedTheme,
      overrides: {
        MuiCardContent:{
          root:{
            // padding: selectedTheme.palette.primary.main + ' solid 3px',
            },
        },
     
      },
  
    })
  }